/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box } from "../../../../components";
import { withProcedureWraper } from "../..";
import { MyRequests } from "./components";
import { MyApprovals } from "./components";
import CreateRequestButton from "../../components/CreateRequestButton";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../AppRoutes";

const SummaryEmployeeRequest = withProcedureWraper(() => {
  const history = useHistory();

  return (
    <div className="pd15">
      <div
        className="text-md-left font-weight-normal p-3 bg-info text-white"
        style={{ fontSize: "14px" }}
      >
        <div className="row title__process-container">
          <div className="">Bảng đăng ký nhân sự tham gia khóa học</div>
          <div className="See-User-Manual">
            <a
              href="#"
              target="_blank"
              rel="noreferrer"
              className="See-User-Manual ml-1"
            >
              Xem hướng dẫn sử dụng
            </a>
          </div>
        </div>
      </div>

      <Box
        title="Yêu cầu của tôi"
        titleRight={
          <CreateRequestButton
            onClick={() =>
              history.push(
                Routes.summaryEmployeeRequestCreatePage.path.replace(":id", "0")
              )
            }
          />
        }
      >
        <MyRequests />
      </Box>
      <Box title="Các yêu cầu cần duyệt">
        <MyApprovals />
      </Box>
    </div>
  );
});

export default SummaryEmployeeRequest;